import React, { Fragment, useState, useEffect, memo } from "react";
import { Popover, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import { completeUserProfile, getCurrentUser } from "../Services/usersApi";
import RegionColors from "./RegionColors";
import { getAuth } from "firebase/auth";
import HeidiLogo from "../assets/HEIDI_Logo.png";
import HeidiBlackLogo from "../assets/heidi_black_logo.png";

function HomePageNavBar({user, setUser, showBlackLogo = false}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navigateTo = (path) => {
    if (path) {
      navigate(path);
    }
  };
  const auth = getAuth();
  // const [user, setUser] = useState();
  const [userId, setUserId] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [terminalView, setTerminalView] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const terminalViewParam = queryParams.get("terminalView");

  const isTerminalScreenEnvEnabled =
    process.env.REACT_APP_ENABLE_TERMINALSCREEN === "True";

  const isTerminalScreenEnabled =
    isTerminalScreenEnvEnabled && terminalViewParam === "true";

  const buttonClass = terminalView === "true" ? "hidden" : "visible";

  useEffect(() => {
    setTerminalView(isTerminalScreenEnabled);
    const accessToken =
      window.localStorage.getItem("accessToken") ||
      window.sessionStorage.getItem("accessToken");

    if (!accessToken) {
      return;
    }

    async function fetchData() {
      try {
        const profileResponse = await getCurrentUser();
        const fetchedUser = profileResponse.data;
        setUser(fetchedUser);
      } catch (err) {
        try {
          const profileResponse = await completeUserProfile();
          const fetchedUser = profileResponse.data.data;
          setUser(fetchedUser);
        } catch (err2) {
          console.error("Profile completion failed:", err2);
        }
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    const accessToken =
      window.localStorage.getItem("accessToken") ||
      window.sessionStorage.getItem("accessToken");
    const refreshToken =
      window.localStorage.getItem("refreshToken") ||
      window.sessionStorage.getItem("refreshToken");
    const storedUserId =
      window.localStorage.getItem("userId") ||
      window.sessionStorage.getItem("userId");

    if (accessToken || refreshToken) {
      setIsLoggedIn(true);
      setUserId(storedUserId);
    }
  }, []);

  const handleLoginLogout = () => {
    if (isLoggedIn) {
      handleLogout();
    } else {
      navigateTo("/login");
    }
  };

  const handleLogout = async () => {
    try {
      if (isLoggedIn) {
        await auth.signOut();
        window.localStorage.clear();
        window.sessionStorage.clear();
        localStorage.removeItem("chakra-ui-color-mode");
        // clearCookies();
        clearStorage();
        setIsLoggedIn(false);
        navigateTo("/login");
      }
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  function clearStorage() {
    window.localStorage.removeItem("accessToken");
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("userId");
    window.localStorage.removeItem("selectedItem");
    window.sessionStorage.removeItem("accessToken");
    window.sessionStorage.removeItem("refreshToken");
    window.sessionStorage.removeItem("userId");
    window.sessionStorage.removeItem("selectedItem");
    setIsLoggedIn(false);
    navigateTo("/");
  }

  // Might ned the logic in the future
  // const clearCookies = () => {
  //   const cookies = document.cookie.split(";");
  //   cookies.forEach((cookie) => {
  //     const cookieName = cookie.split("=")[0].trim();
  //     document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  //   });
  // };

  const handleGotoDashboard = () => {
    navigateTo("/Dashboard");
     localStorage.setItem("expandedMenus", JSON.stringify({
    forum: false,
    listing: true,
    booking: false,
    container: false,
    admin: false
  }));

  localStorage.setItem("activeSubmenu", JSON.stringify({
    forum: "",
    listing: "myEntries",
    booking: "",
    container: "",
    admin: "",
    appdashboard: ""
  }));

  };
  return (
    <div
      className={`w-full fixed top-0 z-10 h-20 flex px-5 md:px-10 lg:px-[10rem] 2xl:px-[20rem] py-2
    ${
      terminalView ? "items-start justify-start" : "items-center justify-center"
    } 
    ${
      ["/", "/AllListings"].includes(location.pathname)
        ? "bg-gradient-to-b from-black to-transparent"
        : "bg-white"
    }`}
    >
      {terminalView ? (
        <div className="flex items-center">
          <img
            onClick={() => navigate("/")}
            className="mx-auto h-32 w-auto cursor-pointer"
            src={HeidiLogo}
            alt="HEDI- Heimat Digital"
          />
        </div>
      ) : (
        <Popover className="w-full">
          <div className="w-full">
            <div
              className={`flex items-center justify-between border-gray-100 lg:space-x-10`}
            >
              <div>
                <img
                  onClick={() => navigate("/")}
                  className="mx-auto h-32 w-auto cursor-pointer"
                  src={showBlackLogo ? HeidiBlackLogo : HeidiLogo}
                  alt="HEDI- Heimat Digital"
                />
              </div>

              {isLoggedIn ? (
                <div className={`-my-2 -mr-2 lg:hidden ${buttonClass}`}>
                  <Popover.Button className="inline-flex items-center justify-center rounded-xl bg-gray-900 p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500">
                    <span className="sr-only">Open menu</span>
                    <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              ) : (
                <div className={`lg:hidden ${buttonClass}`}>
                  <button
                    onClick={() => navigateTo("/login")}
                    className={`font-bold ${
                      ["/", "/AllListings"].includes(location.pathname)
                        ? "text-white"
                        : RegionColors.darkTextColorV2
                    } inline-flex items-center justify-center whitespace-nowrap cursor-pointer ${buttonClass}`}
                  >
                    {t("login")}
                  </button>
                </div>
              )}

              <div className="hidden items-center justify-end lg:flex md:flex-1 lg:w-0 space-x-15">
                {isLoggedIn && (
                  <a
                    className={`${
                      ["/", "/AllListings"].includes(location.pathname)
                        ? "text-white"
                        : RegionColors.darkTextColorV2
                    } border font-bold rounded-full text-sm p-2 text-center inline-flex items-center cursor-pointer ${buttonClass}`}
                    onClick={() => {
                      navigateTo("/Favorite");
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-5 h-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                      ></path>
                    </svg>
                  </a>
                )}

                <a
                  onClick={handleLoginLogout}
                  className={`ml-8 font-bold ${
                    ["/", "/AllListings"].includes(location.pathname)
                      ? "text-white"
                      : RegionColors.darkTextColorV2
                  } inline-flex items-center justify-center whitespace-nowrap cursor-pointer ${buttonClass}`}
                >
                  {isLoggedIn ? t("logOut") : t("login")}
                </a>

                {isLoggedIn && (
                  <a
                    onClick={handleGotoDashboard}
                    className={`ml-8 font-bold ${
                      ["/", "/AllListings"].includes(location.pathname)
                        ? "text-white"
                        : RegionColors.darkTextColorV2
                    } inline-flex items-center justify-center whitespace-nowrap cursor-pointer ${buttonClass}`}
                  >
                    {t("dashboard")}
                  </a>
                )}

                {isLoggedIn && (
                  <a
                    onClick={() => {
                      localStorage.setItem(
                        "selectedItem",
                        t("chooseOneCategory")
                      );
                      isLoggedIn
                        ? navigateTo("/UploadListings")
                        : navigateTo("/login");
                    }}
                    className={`ml-8 font-bold ${
                      ["/", "/AllListings"].includes(location.pathname)
                        ? "text-white"
                        : RegionColors.darkTextColorV2
                    } inline-flex items-center justify-center whitespace-nowrap cursor-pointer ${buttonClass}`}
                  >
                    {t("submit")}
                  </a>
                )}

                {isLoggedIn && (
                  <button
                    onClick={() => navigateTo(`/ViewProfile/${userId}`)}
                    className={`ml-8 ${
                      ["/", "/AllListings"].includes(location.pathname)
                        ? "text-white"
                        : RegionColors.darkTextColorV2
                    } border font-bold rounded-full w-10 h-10 overflow-hidden text-sm p-1 text-center inline-flex items-center justify-center cursor-pointer ${buttonClass}`}
                    title="View Profile"
                  >
                    {(!user?.image)?<svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-5 h-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M5.121 17.804A9 9 0 0112 15c2.444 0 4.667.98 6.279 2.585M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>:
                    <img src={user?.image} alt="profile" className="rounded-full h-full w-full object-cover"/>
                    }
                  </button>
                )}
              </div>
            </div>
          </div>

          <Transition
            as={Fragment}
            enter="duration-200 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              className="absolute inset-x-0 top-0 origin-top-right transform p-2 transition lg:hidden"
            >
              <div
                className={`${RegionColors.darkBgColorV2} divide-y-2 divide-gray-50 rounded-xl`}
              >
                <div className="space-y-6 py-6 px-5">
                  <div className="mr-2 flex justify-between">
                    <div className="flex items-center space-x-3">
                      {isLoggedIn && (
                        <button
                          className="text-white border 
                              font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center
                              cursor-pointer"
                          onClick={() => navigateTo("/Favorite")}
                          title="Favorites"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeWidth="2"
                              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                            ></path>
                          </svg>
                        </button>
                      )}

                      {isLoggedIn && (
                        <button
                          onClick={() =>
                            navigateTo(
                              user
                                ? `/ViewProfile/${user.username}`
                                : "/ViewProfile"
                            )
                          }
                          className="text-white border 
                              font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center
                              cursor-pointer"
                          title="Profile"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeWidth="2"
                              d="M5.121 17.804A9 9 0 0112 15c2.444 0 4.667.98 6.279 2.585M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                        </button>
                      )}
                    </div>

                    <Popover.Button className="inline-flex items-center justify-center rounded-xl bg-blck p-2 text-white">
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>

                  <div>
                    <a
                      onClick={handleLoginLogout}
                      className="font-bold text-white inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
                    >
                      {isLoggedIn ? t("logOut") : t("login")}
                    </a>
                  </div>

                  {isLoggedIn && (
                    <div>
                      <a
                        onClick={handleGotoDashboard}
                        className="font-bold text-white inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
                      >
                        {t("dashboard")}
                      </a>
                    </div>
                  )}

                  {isLoggedIn && (
                    <div>
                      <a
                        onClick={() =>
                          isLoggedIn
                            ? navigateTo("/UploadListings")
                            : navigateTo("/login")
                        }
                        className="font-bold text-white inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
                      >
                        {t("submit")}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>
      )}
    </div>
  );
}

export default memo(HomePageNavBar);